import { render, staticRenderFns } from "./text.vue?vue&type=template&id=ecbdaf4c&"
import script from "./text.vue?vue&type=script&lang=js&"
export * from "./text.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "text.vue"
export default component.exports